import React from 'react';
import { deleteProd } from '../commonRequests';
import ErrorModal from '@/src/components/ErrorModal/ErrorModal';
import ErrorModalTitle from '@/src/components/ErrorModal/ErrorModalTitle';
const deleteProduct = (uuid) => {
  deleteProd(uuid);
};
export const onDelete = (
  uuid,
  setShowModal,
  setModalContent,
  setModalTitle,
) => {
  const _d = () => {
    deleteProduct(uuid);
  };
  setShowModal(true);
  setModalContent(
    <ErrorModal
      setModal={setShowModal}
      onSubmit={_d}
      okText='Delete'
      errorText={
        'This product is about to be permanently deleted. Do you still want to continue?'
      }
    />,
  );
  setModalTitle(<ErrorModalTitle>Delete product</ErrorModalTitle>);
};
